/**
 * Het kruimelpad als gegevens (ronde 5): hoe een pad wordt opgeschoond voordat
 * `Breadcrumbs` het tekent.
 */
import { groupForSection, navGroups, sectionForPath } from "@/fixtures/navigation";
import { SCHEIDING } from "@/lib/numbers";

export type Crumb = {
  label: string;
  /** Laatste kruimel heeft geen link: dat is de pagina waar je al bent. */
  to?: string;
};

const GROEPEN = new Set(navGroups.map((group) => group.title));

/**
 * Eén kruimelpad op elk scherm (ronde 5, punt S1 van de controle):
 *
 * - een label met " · " erin ("Ons bezit · Vastgoed") wordt losse kruimels, zodat
 *   er één scheidingsteken met één afstand staat. De link van het samengestelde
 *   label gaat naar het laatste deel;
 * - het pad begint altijd bij de groep uit het menu ("Ons bezit", "Sturen en
 *   plannen", "Verantwoorden", "Overzicht"). Begint een scherm lager ("Vastgoed"
 *   op een dossier, "Dashboard" op de keten), dan staat de groep ervoor.
 */
export function normalizeCrumbs(items: Crumb[], pathname: string): Crumb[] {
  const los = items.flatMap((crumb) => {
    const delen = crumb.label.split(SCHEIDING).map((deel) => deel.trim()).filter(Boolean);
    if (delen.length <= 1) return [crumb];
    return delen.map((label, index) => (index === delen.length - 1 ? { ...crumb, label } : { label }));
  });
  if (los.length === 0 || GROEPEN.has(los[0].label)) return los;
  const sectie = sectionForPath(pathname);
  const groep = sectie ? groupForSection(sectie) : undefined;
  if (!groep) return los;
  // "Dashboard" of "Vastgoed" vooraan: de groep komt ervoor. Staat de sectie er
  // niet in, dan ook niet zelf toevoegen: de schermen kiezen hun eigen tussenstap.
  return [{ label: groep.title }, ...los];
}
